module.exports = __webpack_public_path__ + "static/img/alb.9c90c9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alb.jpg
// module id = JqmZ
// module chunks = 1